<template>
    <div class="col-sm-4" v-if="can('settings.edit','return.services.index','settings.booking-index')">
        <div class="card">
            <div class="card-header">
                <h1 class="card-title">{{i18n("Settings")}}</h1>
            </div>
            <div class="card-body">
                <ul class="list-unstyled grid-list">
                    <router-link to="/settings" tag="li" v-if="can('settings.edit')">
                        <a href="#" title="">{{i18n("Options")}}</a>
                    </router-link>
                    <router-link to="/return-services" tag="li" v-if="can('return.services.index')">
                        <a href="#" title="">{{i18n("Returns")}}</a>
                    </router-link>
                    <router-link to="/booking" tag="li" v-if="can('settings.booking-index')">
                        <a href="#" title="">{{i18n("Booking")}}</a>
                    </router-link>
                    <router-link :to="{ name: 'booking-list'}" tag="li" v-if="can('settings.booking-list')">
                        <a href="#" title="">{{i18n("Booking List")}}</a>
                    </router-link>
                    <!-- alx e-pos -->
                    <router-link to="/epos-services" tag="li" v-if="can('settings.edit')">
                        <a href="#" title="">{{i18n("E-POS")}}</a>
                    </router-link>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "SettingsCard"
    }
</script>

<style scoped>

</style>
